function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.936 5h.075a4.485 4.485 0 013.174 1.319 4.505 4.505 0 01-1.457 7.338A4.484 4.484 0 0117.01 14v-1.5a3.003 3.003 0 000-6h-1.371l-.184-1.285a3.736 3.736 0 00-3.19-3.183A3.717 3.717 0 008.346 4.25l-.5 1.143-1.213-.284A3.735 3.735 0 005.784 5a3.733 3.733 0 00-3.667 3.017A3.754 3.754 0 005.784 12.5h.747V14h-.747a5.228 5.228 0 01-3.942-1.74A5.253 5.253 0 014.78 3.59a5.193 5.193 0 012.202.06A5.229 5.229 0 0112.467.56 5.219 5.219 0 0116.936 5zM9.06 12.681l1.971 1.972V6.5h1.492v8.1l1.917-1.918 1.06 1.06-3.219 3.22h-1.062L8 13.743l1.06-1.062z",
  fill: "#19496B"
});

var SvgBespokenDownloadIcon2 = function SvgBespokenDownloadIcon2(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 22 17",
    fill: "none"
  }, props), _ref);
};

export default SvgBespokenDownloadIcon2;